import { useQuery } from '@tanstack/react-query';
import { productAttributeService } from '@/services/admin/productAttributeService';
import type { Attribute } from '@/services/admin/productAttributeService';

export const useProductAttributes = (productId: string) => {
  const { data: attributes = [], isLoading, error } = useQuery({
    queryKey: ['product-attributes', productId],
    queryFn: () => productAttributeService.fetchAttributes(productId),
    enabled: !!productId,
    staleTime: 300_000,
  });

  return { attributes, isLoading, error: error ? (error as Error).message : null };
};
